import appboy from 'appboy-web-sdk';
import logger from 'utils/logger';

const log = logger.extend('braze');

// Set REACT_APP_BRAZE_TOKEN per environment (.env locally, deploy config in CI).
// When it is missing braze stays disabled and everything below is a no-op.
// Since the app is deprecated, code will not be deployed
const BRAZE_TOKEN = process.env.REACT_APP_BRAZE_TOKEN;

let initialized = false;

const initBrazeLib = () => {
  if (!BRAZE_TOKEN) {
    log('no REACT_APP_BRAZE_TOKEN set - braze disabled');
    return;
  }

  log('init and open session');

  appboy.initialize(BRAZE_TOKEN, {
    baseUrl: 'https://cursa.iad-03.braze.com/api/v3'
  });

  appboy.openSession();
  initialized = true;
};

const logCustomEvent = (eventName, payload) => {
  if (!initialized) return;

  log('logCustomEvent', eventName, payload);
  appboy.logCustomEvent(eventName, payload);
};

const setUser = user => {
  if (!initialized) return;

  log('setUser');
  if (user.external_id) {
    appboy.changeUser(user.external_id);
  } else {
    log(`no externalId found for user ${user.email}`);
  }
};

export default { initBrazeLib, logCustomEvent, setUser };
